export const IntegrationAppNames = {
  QUICKBOOKS_ONLINE: 'QuickBooks Online'
};